export default {
  YTK_HOST: '//ytk.yuanfudao.com',
  YST_HOST: '//xyst.yuanfudao.com',
  SOLAR_OPEN_HOST: '//xyst-open.yuanfudao.com',
  YTK_GALLERY: '//gallery.fbcontent.cn/api/ape/images/'
}



// WEBPACK FOOTER //
// ./src/config/online.js